import supabase from '../supabase/supabase';

export const AUDIT_TABLE = 'moderation_audit_logs_1786745000000';
export const REPORTS_TABLE = 'chat_reports_1786745000000';

export async function logAdminAction(adminUsername, actionType, targetUser, details) {
  try {
    await supabase.from(AUDIT_TABLE).insert({
      admin_username: adminUsername || 'Administrador',
      action_type: actionType,
      target_user: targetUser || '',
      details: details || ''
    });
  } catch (err) {
    console.warn('Error al registrar auditoría:', err);
  }
}